// Current Lodge Selectors

export const getResortLocation = state => {
  return state.resortLocation;
};
